import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from './router'
import zhCN from './i18n/zh-CN'
import enUS from './i18n/en-US'
import './styles/main.css'
import './styles/2.5d.css'

const savedLocale = typeof navigator !== 'undefined'
  ? (navigator.language.startsWith('zh') ? 'zh-CN' : 'en-US')
  : 'zh-CN'

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
  },
})

const app = createApp(App)
app.use(i18n)
app.use(router)
app.mount('#app')
